import { bool, number, func } from "prop-types";
import { IconButton } from "@material-ui/core";
import { Pause, PlayArrow, Replay } from "@material-ui/icons";

export const PlayButton = ({
  isPlaying,
  playTime,
  totalTime,
  pause,
  resume,
}) => (
  <IconButton
    color="inherit"
    onClick={isPlaying ? pause : resume}
    className="text-4xl"
    style={{ justifySelf: "center" }}
  >
    {
      isPlaying
        ? <Pause />
        : playTime === totalTime
          ? <Replay />
          : <PlayArrow />
    }
  </IconButton>
)

PlayButton.propTypes = {
  isPlaying: bool.isRequired,
  playTime: number.isRequired,
  totalTime: number.isRequired,
  pause: func.isRequired,
  resume: func.isRequired,
}